(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapin-fragrance-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tapin-fragrance-finder')){customElements.define('tapin-fragrance-finder',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('form').addEventListener('submit',event=>{event.preventDefault();const data=new FormData(event.currentTarget);let count=0;this.querySelectorAll('[data-match]').forEach(card=>{const match=(!Number(data.get('budget'))||Number(card.dataset.price)<=Number(data.get('budget')))&&(data.get('scent')==='any'||card.dataset.scent.split(',').includes(data.get('scent')))&&(data.get('occasion')==='any'||card.dataset.occasion.split(',').includes(data.get('occasion')));card.hidden=!match;if(match)count++});this.querySelector('[data-empty]').hidden=count>0})}})}

  } catch(e) { console.error(e); }
})();
})();
